// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export var TitleVersion;
(function (TitleVersion) {
    TitleVersion["Clickbait"] = "clickBait";
    TitleVersion["Long"] = "long";
    TitleVersion["Short"] = "short";
    TitleVersion["TeaserBox"] = "teaserBox";
})(TitleVersion || (TitleVersion = {}));
